import type { IDBStoreConfig } from './types';
export const DB_NAME = 'labelling';
export const DB_VERSION = 5;
export const Stores = ({
  Task: 'task',
  VideoFrames: 'video-frames',
  VideoEventsJournal: 'video_task_events_journal',
  AnnotationFrames: 'annotation-frames',
  AnnotationMetadata: 'annotation-metadata',
  FetchedRanges: 'fetched-ranges'
} as const);
export const ALL_STORES: IDBStoreConfig[] = [{
  storeName: Stores.Task,
  keyPath: 'id'
}, {
  storeName: Stores.VideoFrames,
  keyPath: 'id'
}, {
  storeName: Stores.VideoEventsJournal,
  keyPath: 'sequence',
  autoIncrement: true,
  indices: [{
    indexName: 'taskID',
    keyPath: 'taskID'
  }]
}, {
  storeName: Stores.AnnotationFrames,
  keyPath: ['taskKey', 'videoId', 'frameIndex', 'annotationId']
}, {
  storeName: Stores.AnnotationMetadata,
  keyPath: ['taskKey', 'videoId', 'annotationId']
}, {
  storeName: Stores.FetchedRanges,
  keyPath: ['taskKey', 'videoId']
}];